/* import __COLOCATED_TEMPLATE__ from './continued-conversations-toggle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();